import { CancelOrderReasonsService } from '@/backend/market'
import { CancelOrderReasonRepository } from '../../domain/repositories/CancelOrderReasonRepository'
import { CancelOrderReasonModel } from '../models/CancelOrderReasonModel'
import { CancelOrderReasonsFilterModel } from '../models/CancelOrderReasonsFilterModel'
import type { CancelOrderReasonsFilterEntity } from '../../domain/entities/CancelOrderReasonsFilterEntity'
import type { CancelOrderReasonEntity } from '../../domain/entities/CancelOrderReasonEntity'
import { CancelOrderReasonMiniModel } from '../models/CancelOrderReasonMiniModel'
import type { CancelOrderReasonMiniEntity } from '../../domain/entities/CancelOrderReasonMiniEntity'
import type { CreateUpdateCancelOrderReasonEntity } from '../../domain/entities/CreateUpdateCancelOrderReasonEntity'
import { CreateUpdateCancelOrderReasonModel } from '../models/CreateUpdateCancelOrderReasonModel'

export class CancelOrderReasonRepositoryImpl implements CancelOrderReasonRepository {
  async getCancelOrderReasons(
    filterData: CancelOrderReasonsFilterEntity
  ): Promise<CancelOrderReasonMiniEntity[] | { error: true }> {
    try {
      const cancelOrderReasonsFilterModel = new CancelOrderReasonsFilterModel(filterData)
      const response = await CancelOrderReasonsService.getCancelOrderReasonsAdmin(
        cancelOrderReasonsFilterModel
      )
      const cancelOrderReasonModels = response.map(
        (reason) => new CancelOrderReasonMiniModel(reason)
      )
      return cancelOrderReasonModels
    } catch {
      return { error: true }
    }
  }
  async getCancelOrderReasonById(id: number): Promise<CancelOrderReasonEntity | { error: true }> {
    try {
      const response = await CancelOrderReasonsService.getCancelOrderReasonByIdAdmin({
        id
      })
      const cancelOrderReasonModel = new CancelOrderReasonModel(response)
      return cancelOrderReasonModel
    } catch {
      return { error: true }
    }
  }
  async createCancelOrderReason(
    data: CreateUpdateCancelOrderReasonEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdateCancelOrderReasonModel = new CreateUpdateCancelOrderReasonModel(data)
    try {
      await CancelOrderReasonsService.postCancelOrderReasonAdmin({
        requestBody: createUpdateCancelOrderReasonModel
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateCancelOrderReason(
    id: number,
    data: CreateUpdateCancelOrderReasonEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdateCancelOrderReasonModel = new CreateUpdateCancelOrderReasonModel(data)
    try {
      await CancelOrderReasonsService.putCancelOrderReasonAdmin({
        id,
        requestBody: createUpdateCancelOrderReasonModel
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deleteCancelOrderReason(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await CancelOrderReasonsService.deleteCancelOrderReasonAdmin({
        id
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
